import { useStore, useDispatch } from "react-reducer-store"
import { BRANCHES_BY_COMPANY_NAME } from "../core/api/queries"
import { useApolloClient } from "@apollo/client"

const APP = {
  notification: {
    show: "NOTIFICATION_SHOW",
    hide: "NOTIFICATION_HIDE",
  },
  confirmation: {
    show: "CONFIRMATION_SHOW",
    hide: "CONFIRMATION_HIDE",
  },
  createTicket: {
    show: "CREATE_SHOW",
    hide: "CREATE_HIDE",
  },
  loading: true,
  appId: "APP_ID",
  setBranches: "SET_BRANCHES"
}

const company = localStorage.getItem("OMNI_SELECTED_COMPANY")
const AppActions = () => {
  const dispatch = useDispatch()
  const app = useStore( state => state.app )
  const client = useApolloClient()

  const hideNotification = () => dispatch({ type: APP.notification.hide })

  const showNotification = message =>
    dispatch({ type: APP.notification.show, payload: message })

  const hideConfirmation = () => dispatch({ type: APP.confirmation.hide })

  const showConfirmation = message =>
    dispatch({ type: APP.confirmation.show, payload: message })

  const hideCreateTicket = () => dispatch({ type: APP.createTicket.hide })

  const showCreateTicket = () =>
      dispatch({ type: APP.createTicket.show })
  
  const isShowCreateTicket = () => true

  const setLoading = payload => dispatch({ type: APP.loading }, payload)

  const setAppId = payload => dispatch({ type: APP.appId, payload })

  const setBranches = payload => dispatch({ type: APP.setBranches, payload })

  const getBranchById = async (id) => {
    const branchesFromStore = await getBranches()
    if( branchesFromStore ){
      const b = branchesFromStore.filter(e => e._id === id)
      return b.length > 0 ? b[0] : {}  
    }
  }

  const getBranches = async ( companyName = company ) => {
    if( app && app.branches && app.branches.length > 0 ){
      return app.branches
    }
    return await getBranchesByCompany(companyName)
  }

  const getBranchesByCompany = async ( companyName ) => {
    if(companyName){
      const { data, loading } = await client.query({
        query: BRANCHES_BY_COMPANY_NAME,
        variables: { company:companyName },
      })
      if (!loading) {
          const { branches } = data
          const cleanedData = [{name:"", _id:null}]
          branches.map( e => { cleanedData.push( { name: e.name, _id: e._id } ) } ) 
          setBranches(cleanedData)
          return cleanedData
      }  
    }
  }

  return {
    hideNotification,
    showNotification,
    hideConfirmation,
    showConfirmation,
    showCreateTicket,
    hideCreateTicket,
    isShowCreateTicket,
    setLoading,
    setAppId,
    setBranches,
    getBranchById,
    getBranches
  }
}

export { APP, AppActions }
